import React, { Component } from 'react';

export default class TemplateOne extends Component {
  render() {
    return (
      <div className="row toPrint" style={{ marginBottom: 30 }}>
        <div className="alert alert-info">
          hapi is a simple to use configuration-centric framework with built-in support for input validation, caching, authentication,
                and other essential facilities for building web and services applications.
                hapi enables developers to focus on writing reusable application logic in a highly modular and prescriptive approach.
                Version 17.x only supports node v8.9.0 and over. For older version of node please use version 16.x.
              </div>
        <h4>
          Sponsorship
              </h4>
        <p>
          Development of the hapi core module generously supported by contributions from individuals and corporations.
              If you are benefiting from hapi and would like to help keep the project financially sustainable, please visit Eran hammer{"'"}s Patreon page or contact him via email.
              </p>
        <div>
          checking state :: {this.props.DataFrmMainpage.showMyTemplate ? 'No! Take it away!' : 'Yes! Please!'}
        </div>
      </div>
    );
  }
}
